
@if (this.actividadTareas$ | async; as actividades ) {
    <ng-container>
        <actividad-reciente [ActividadReciente]="actividades"></actividad-reciente>
    </ng-container>
} @else {
    <div class="flex items-center justify-center h-64">
        <div class="text-2xl font-medium text-gray-400">No hay Archivos Asociados</div>
    </div>
}
    